/**
 * @CART lib  © MyPASS S.r.l All Rights reserved
 * This lib is used to add bi-directional adapters for old apis and new apis
 * 
 * @Interfaces
 * 
 * 
 * 
 * 
 */



/*
POST
    addToCart
    code: "new,new"
    date_of_birth: "1980-05-05,1980-05-05"
    gender: "m,m"
    language: "en"
    name: "Ali,Ali2"
    number_of_services_adult: ""
    number_of_services_reduced: ""
    provider: "skidata,axess"
    shipment: "0,0"
    surname: "Bakhtiar,Bakhtiar"
    type: "adult,adult"


 POST
    /service/addItemToShoppingCart
    item_desc: {"item_desc" : {"name":"Mario","surname":"Rossi","date_of_birth":"1990-03-05","provider":"axess/skidata","gender":"m/f","code":"30-1234123412341234-1","shipment":"0/1"}
    item_type: ski_service,voucher
 */
import { Config } from '../Config';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export function addToCartToAddItemToShoppingCart(params) {

    /**
     DEPRECATED:
        number_of_services_adult,
        number_of_services_reduced,
        type,        
     */

    const {
        code,
        date_of_birth,
        gender,
        name,
        provider,
        shipment,
        surname
    } = params;

    let convertedParams = {
        item_desc: {
            code: code.split(',')[code.split(',').length - 1],
            date_of_birth: date_of_birth.split(',')[date_of_birth.split(',').length - 1],
            gender: gender.split(',')[gender.split(',').length - 1],
            name: name.split(',')[name.split(',').length - 1],
            provider: provider.split(',')[provider.split(',').length - 1],
            shipment: shipment.split(',')[shipment.split(',').length - 1],
            surname: surname.split(',')[surname.split(',').length - 1],
        },
        item_type: params.discount? 'voucher':'ski_service'
    }
    //extracting only first 
    console.log('code.split addToCartToAddItemToShoppingCart', convertedParams);

    return convertedParams;

}

export async function getShoppingCartToCheckCartConverter(params) {
    /*
amount: "10.00"
cart_id: 14
code: "new"
date_of_birth: "1995-11-05"
gender: "m"
item_id: 315
name: "Tets"
provider: "skidata"
shipment: "0"
surname: "Testtt"
type: "ski_service"
*/

    /*
                        number_of_services_adult: sepStrArr[0],
                        number_of_services_reduced: sepStrArr[1],
                        code: sepStrArr[2].split(",")[i],
                        provider: sepStrArr[3].split(",")[i],
                        type: sepStrArr[4].split(",")[i],
                        shipment: sepStrArr[5].split(",")[i],
                        name: sepStrArr[6].split(",")[i],
                        surname: sepStrArr[7].split(",")[i],
                        date_of_birth: sepStrArr[8].split(",")[i],
                        gender: sepStrArr[9].split(",")[i],
    */
    //cart: "2_0_new,new_skidata,axess_adult,adult_0,0_Tets,tets11_Testtt,testtt_1995-11-05,1995-11-05_m,m_null"
    //      1_0_new_skidata_ski_service_0_Tets_Testtt_1995-11-05_m
    console.log('getShoppingCartToCheckCartConverter: @params', params);
    if (params.status == 'success') {
        const { cart } = params;
        let modified_cart = '';

        let itemNumber = 0;
        let code = '';
        let provider = '';
        let type = '';
        let shipment = '';
        let name = '';
        let surname = '';
        let date_of_birth = '';
        let gender = '';
        let item_id = '';

        //removing entry with type 'shipment' since we can not deal with it in this stage
        // if item is included a voucher(at the time of coding) type = "undefined"
        let theCart = cart.filter(function (el) { 
            return el.type != 'shipment' && el.type != "voucher";
        });


        // console.log('getcategorytype in the cart: ', await checkCategory("2016-11-05"));
        
        
        for (let index = 0; index < theCart.length; index++) {
            const element = theCart[index];
            
        // }
        // theCart.forEach((element, index) => {
            let cat = await checkCategory(element.date_of_birth);
            itemNumber++;
            if (index == 0) {
                code = element.code;
                provider = element.provider;
                type =cat.type;//always adult since in the 'ski_service' makes trouble because of underscore. Later, we get type by api and passing date of birth 
                shipment = element.shipment;
                name = element.name;
                surname = element.surname;
                date_of_birth = element.date_of_birth;
                gender = element.gender;
                item_id = element.item_id;
            } else {
                code += ',' + element.code;
                provider += ',' + element.provider;
                type += ',' +cat.type;
                shipment += ',' + element.shipment;
                name += ',' + element.name;
                surname += ',' + element.surname;
                date_of_birth += ',' + element.date_of_birth;
                gender += ',' + element.gender;
                item_id += ',' + element.item_id;
            }
        };
        modified_cart = itemNumber + '_' +
            '0_' +
            code + '_' +
            provider + '_' +
            type + '_' +
            shipment + '_' +
            name + '_' +
            surname + '_' +
            date_of_birth + '_' +
            gender + '_' +
            item_id;

        console.log('modified_cart: ', modified_cart);

        params.cart = modified_cart;

    }

    return params;

}

// parse objet to uri params string
// @return string : URI formatted params
function objectToURIParams(obj) {
    var str = "";
    for (var key in obj) {
      if (str == "") {
        str = (!Config.publish) ? "?" : "&";
      } else {
        str += "&";
      }
      str += key + "=" + encodeURIComponent(obj[key]);
    }
    return str;
  }

async function checkCategory(data_nasc) {
    let url = Config.hostUrl + 'service/checkCategory' + objectToURIParams({ date_of_birth: data_nasc, language:'en' });
    console.log('calling rest @', url);
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.get('access_token'),
            },
        });
        const response_1 = response.json();
        return response_1;
    }
    catch (e) {
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
            return null;
        }
    }
  }


// WEBPACK FOOTER //
// ./src/libs/cart.js